import React, { useState } from "react";
import MobilePageLayout from "../components/MobilePageLayout";
import StepProgress from "../components/StepProgress";
import HomeButton from "../components/HomeButton";

const AuthPage = ({ phone, userName, email, onNext }) => {
  const [otp, setOtp] = useState("");
  const [name, setName] = useState(userName || "");
  const [userEmail, setUserEmail] = useState(email || "");

  const handleNext = () => {
    if (!otp || !name || !userEmail) return alert("Fill all fields");
    onNext({ phone, otp, name, email: userEmail });
  };

  return (
    <MobilePageLayout ctaLabel="Verify & Continue" onCtaClick={handleNext}>
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <StepProgress current={3} />
      <HomeButton />

      <h2 className="page-title">Authenticate</h2>

      <div className="field-group">
        <div className="field">
          <label>OTP Code</label>
          <input value={otp} onChange={(e) => setOtp(e.target.value)} />
        </div>

        <div className="field">
          <label>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </div>

        <div className="field">
          <label>Email</label>
          <input value={userEmail} onChange={(e) => setUserEmail(e.target.value)} />
        </div>
      </div>
    </MobilePageLayout>
  );
};

export default AuthPage;
